import { Field, HelpTooltip } from '~/components';
import React from 'react';
import styled from 'styled-components';

const Control = styled.div`
  display: flex;
  align-items: center;
`;

export default function CapAssignedHoursCheckbox({ useRoles }) {
  return (
    <Control>
      <Field.Checkbox name="capAssignedHours" label={`Cap the hours by ${useRoles ? 'role' : 'member'}`} />

      <HelpTooltip
        message={`Do not allow a time entry to be saved if it will cause the project to exceed its ${useRoles ? 'role' : 'member'} hours budget.`}
        style={{ marginLeft: '.5rem' }}
      />
    </Control>
  );
}
